export enum EventRequestTypeSelection {
  open = 'open',
  decided = 'decided',
}
